var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54133 18.2344C11.8653 16.1891 16 12.0104 16 8.17578C16 6.05405 15.1571 4.01922 13.6569 2.51893C12.1566 1.01864 10.1217 0.175781 8 0.175781C5.87827 0.175781 3.84344 1.01864 2.34315 2.51893C0.842855 4.01922 3.16163e-08 6.05405 0 8.17578C0 12.0104 4.13333 16.1891 6.45867 18.2344C6.88282 18.613 7.43147 18.8223 8 18.8223C8.56853 18.8223 9.11718 18.613 9.54133 18.2344ZM5.33333 8.17578C5.33333 7.46854 5.61428 6.79026 6.11438 6.29016C6.61448 5.79007 7.29276 5.50911 8 5.50911C8.70724 5.50911 9.38552 5.79007 9.88562 6.29016C10.3857 6.79026 10.6667 7.46854 10.6667 8.17578C10.6667 8.88303 10.3857 9.5613 9.88562 10.0614C9.38552 10.5615 8.70724 10.8424 8 10.8424C7.29276 10.8424 6.61448 10.5615 6.11438 10.0614C5.61428 9.5613 5.33333 8.88303 5.33333 8.17578Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.14d87162b75e9eb3331e33780768f0fd.svg";
export { ForwardRef as ReactComponent };